import { PhoneType } from "../../types";
import { BasicAccountApplicationDocument } from "../../api/commercial/generated-types";

export interface PersonType {
  gender: string;
  firstName: string;
  lastName: string;
  mobile: PhoneType;
  emailBusiness: string;
  correspondenceLanguage: string;
}

export interface BasicAccountBenefitsModel {
  hasCashOnCard: string;
  hasLoyalties: string;
  customizedCard: BasicAccountApplicationDocument["customizedCard"];
  includeInsurancePlus?: boolean;
  plusPartnerUsername?: string;
  isContactPersonSame?: string;
  contactPerson?: PersonType;
  adminContactPerson?: PersonType;
  partnerPlusBenefitGeneralDto?: {
    receiveInfoMail?: boolean;
    sendNewsletters?: boolean;
    companyTravelersCount?: CompanyTravellersCount;
    expectedAnnualFlightSpending?: AnnualFlightSpending;
    companyDepartment?: string;
    companyPosition?: string;
  };
}

export enum AnnualFlightSpending {
  LESS_THAN_10 = "LESS_THAN_10",
  BETWEEN_10_AND_100 = "BETWEEN_10_AND_100",
  BETWEEN_100_AND_200 = "BETWEEN_100_AND_200",
  OVER_200 = "OVER_200",
}

export enum CompanyTravellersCount {
  ONE = "ONE",
  BETWEEN_2_AND_5 = "BETWEEN_2_AND_5",
  BETWEEN_6_AND_10 = "BETWEEN_6_AND_10",
  OVER_10 = "OVER_10",
}
